// generated by srcset-codegen
import src from "./search.svg";

const width = 20;
const height = 20;
export default { src, width, height };
